<template>
  <md-dialog :md-active.sync="showDialog" @md-clicked-outside="closeDialog">
    <div class="custom-header">
      <md-dialog-title>Оцените работу</md-dialog-title>
      <md-button
        class="md-button md-just-icon md-simple"
        @click="closeDialog"
      >
        <i class="material-icons ">close</i>
      </md-button>
    </div>

    <div class="custom-content">
      <div class="md-layout custom-layout">
        <div class="md-layout-item md-size-100">
          <div class="input-wrap">
            <star-rating-control :length="amountRatings" :ratedesc="ratings" v-model="updateData.rating"/>
          </div>
        </div>
        <div class="md-layout-item md-size-100">
          <md-field maxlength="5">
            <label class="comment-label"
                   :class="{'custom-valid-label': updateData.comment.length > 0}">
              Ваш комментарий также очень важен для нас
            </label>
            <md-textarea v-model="updateData.comment"/>
          </md-field>
        </div>
      </div>
    </div>
    <md-dialog-actions class="text-center">
      <md-button class="md-blue md-sm" @click="updateRating">Оценить</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
  import StarRatingControl from '@/components/Custom/StarRatingControl';
  export default {
    name: "AppealsRatingControl",
    components: {
      StarRatingControl,
    },
    data() {
      return {
        ratings: [
          {id: 1, name: 'Ужасно'},
          {id: 2, name: 'Плохо'},
          {id: 3, name: 'Нормально'},
          {id: 4, name: 'Хорошо'},
          {id: 5, name: 'Отлично!'}
        ],
        updateData: {
          comment: '',
          rating: 0,
        },
        showModal: false,
      }
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      amountRatings() {
        if (this.ratings){
          return this.ratings.length;
        }
        return 0;
      },
    },
    methods: {

      makeData() {
        return {
          ratingId: this.updateData.rating,
          comment: this.updateData.comment,
          statusId: 5,
        }
      },

      updateRating() {
        if (this.updateData.rating === 0) {
          this.$notifyDanger('Выберите оценку');
          return;
        }

        const submitData = this.makeData();
        this.$emit('onSubmit', submitData);
        this.closeDialog();
      },

      closeDialog() {
        this.updateData.rating = 0;
        this.updateData.comment = '';
        this.$emit("closeDialog");
      },
    },
  }
</script>

<style lang="scss" scoped>
  .md-dialog {
    max-width: 480px;
    width: 100%;
    .md-dialog-title {
      text-align: center;
    }
    .md-dialog-actions {
      padding: 0 20px 20px 20px !important;
    }
  }

  .custom-layout {
    height: 285px;
    padding: 0 20px;
  }

  .input-wrap {
    text-align: center;
    height: 100px;
  }

  .control-wrap {
    height: 100%;
    &--border {
      border-bottom: 1px solid #ddd;
    }
  }

  .rating-wrap {
    cursor: pointer;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    padding: 5px 0;
    .rating-icon {
      font-size: 22px !important;
      color: #999999;
    }
  }

</style>
